<template>
  <span>
    {{ get_title }}
  </span>
</template>

<script>

import {LOCALE_DATA} from "../../helpers/constants";

export default {
  name: "GetMenuTitle",
  props: {
    default_title: {
      type: String,
      required: true,
    },
    title_array: {
      type: Array,
      required: () => [],
    },
  },
  computed: {
    get_title() {
      if ((typeof this.title_array) === "undefined") return this.default_title
      if (!this.title_array.length || (typeof this.title_array) === "undefined") return this.default_title
      return (this.title_array || []).find(el => el.locale === this.current_locale)?.title || this.default_title
    },
    current_locale() {
      return LOCALE_DATA?.current || LOCALE_DATA?.default || 'en'
    },
  }
}
</script>
